export default (axios, code) => axios.get(`timezone?code=${code}`);
